export type AnalyticsDeviceType = "Desktop" | "Mobile" | "Tablet";

/**
 * A deliberately small, stable device classifier for conversion metadata.
 * PostHog still owns detailed device detection; this value exists so a
 * server-emitted signup event does not lose the browser class entirely.
 */
export function classifyAnalyticsDevice({
  userAgent,
  viewportWidth,
}: {
  userAgent: string;
  viewportWidth?: number | null;
}): AnalyticsDeviceType {
  if (/ipad|tablet|kindle|silk|macintosh.*mobile/i.test(userAgent))
    return "Tablet";
  if (/android/i.test(userAgent) && !/mobi/i.test(userAgent)) return "Tablet";
  if (/mobi|iphone|ipod|android/i.test(userAgent)) return "Mobile";
  if (viewportWidth != null && viewportWidth < 768) return "Mobile";
  return "Desktop";
}

export function readBrowserDeviceType(): AnalyticsDeviceType | null {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return null;
  }
  return classifyAnalyticsDevice({
    userAgent: navigator.userAgent,
    viewportWidth: window.innerWidth,
  });
}

export function normalizeAnalyticsDeviceType(
  value: unknown,
): AnalyticsDeviceType | null {
  return value === "Desktop" || value === "Mobile" || value === "Tablet"
    ? value
    : null;
}
